"use client";

import { Bot } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";

function NotFound() {
  return (
    <Card className="border-none bg-white text-black shadow-lg">
      <CardHeader className="pb-2">
        <div className="mx-auto mb-2 flex items-center justify-center">
          <img
            src="/miniapp/logo-vertical-rus.svg"
            alt="Logo"
            className="w-24 h-24"
          />
        </div>
        <CardTitle className="text-center text-2xl font-bold">
          Регистрация
        </CardTitle>
        <CardDescription className="text-center text-gray-500">
          Чтобы воспользоваться мини-приложением Сообщества выпускников EMBA MBA
          ВШМ СПбГУ завершите создание профиля в Telegram-боте. Cледуйте этим
          шагам:
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <ol className="space-y-2">
          <li className="flex items-start space-x-3">
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D33F44] text-sm font-bold text-white">
              1
            </div>
            <div>
              <p className="font-medium">Открыть наш Telegram Бот</p>
              <p className="text-sm text-gray-500">
                Нажмите кнопку «Открыть Telegram Бот» ниже.
              </p>
            </div>
          </li>

          <li className="flex items-start space-x-3">
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D33F44] text-sm font-bold text-white">
              2
            </div>
            <div>
              <p className="font-medium">Отправьте команду /start</p>
            </div>
          </li>

          <li className="flex items-start space-x-3">
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D33F44] text-sm font-bold text-white">
              3
            </div>
            <div>
              <p className="font-medium">Следуйте инструкциям</p>
            </div>
          </li>

          <li className="flex items-start space-x-3">
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D33F44] text-sm font-bold text-white">
              4
            </div>
            <div>
              <p className="font-medium">Вернитесь в это приложение</p>
              <p className="text-sm text-gray-500">
                Вернитесь сюда после завершения регистрации в боте.
              </p>
            </div>
          </li>
        </ol>
      </CardContent>
      <CardFooter>
        <Button
          variant="ghost"
          className="w-full bg-[#D33F44] hover:bg-[#B8353A] text-white border-none shadow-none"
          onClick={() => {
            const botName =
              window.location.hostname === "tyaga.me"
                ? "gsom_connector_bot"
                : "gsom_connector_staging_bot";
            // Here you would typically open the Telegram bot
            window.open("https://t.me/" + botName, "_blank");
          }}
        >
          Открыть Telegram Бот
          <Bot className="ml-2 h-4 w-4" />
        </Button>
      </CardFooter>
    </Card>
  );
}

export { NotFound };
